import { isPresent } from 'utils/isPresent';
import React from 'react';
import { createSelector } from 'reselect';

export const UPDATE_TAGS_IN_PROGRESS = 'UPDATE_TAGS_IN_PROGRESS';
export const JOB_TYPE = 'JOB_TYPE';
export const CUSTOMER_TYPE = 'CUSTOMER_TYPE';
export const LEAD_TYPE = 'LEAD_TYPE';

export const getPropLabel = (state, props) => props.label;
export const getTagType = (state, props) => props.tagType;
export const isEstimateType = (state, props) => props.isEstimate;

export const getLabel = createSelector([getPropLabel, getTagType, isEstimateType], (label, type, isEstimate) => {
  if (isPresent(label)) {
    return label;
  }

  if (isEstimate) {
    return 'Estimate tags (press enter)';
  }

  switch (type) {
    case CUSTOMER_TYPE:
      return 'Customer tags (press enter)';
    case LEAD_TYPE:
      return 'Lead tags (press enter)';
    case JOB_TYPE:
      return 'Job tags (press enter)';
    default:
      return '';
  }
});

export function addTagInCache(currentTags, tag) {
  if (shouldAddTag(currentTags, tag)) {
    return [...currentTags, tag];
  }
  return currentTags;
}

export function deleteTagInCache(currentTags, tagToDelete) {
  return currentTags.filter((currentTag) => !(currentTag.name === tagToDelete.name));
}

export function shouldAddTag(currentTags, newTag) {
  let tagNames = currentTags.map((tag) => tag.name.toLowerCase());
  return isPresent(newTag.name) && !tagNames.includes(newTag.name.toLowerCase());
}
